import React from "react";
import PropTypes from "prop-types";

import { UIPaginationBar, UITable } from "../../../../components/ui";
import ApplicantsEmptyState from "./ApplicantsEmptyState";

const ApplicantsListPanel = ({
  applicants,
  shared,
  isLoading,
  list,
  rows,
  columns,
  filters,
  meta,
  emptyState,
  onCellClick,
  onSelectionChange,
  onPageChange,
  onPageSizeChange,
}) => {
  const paginationTotal = meta?.count || 0;
  const paginationCurrentPage = meta?.currentPage || filters.page || 1;
  const paginationPageSize = filters.rowsCount || 10;
  const paginationFrom =
    paginationTotal === 0
      ? 0
      : (paginationCurrentPage - 1) * paginationPageSize + 1;
  const paginationTo = Math.min(
    paginationCurrentPage * paginationPageSize,
    paginationTotal,
  );
  const paginationPages =
    meta?.pages || Math.ceil(paginationTotal / paginationPageSize) || 1;

  if (!isLoading && !list?.length) {
    return (
      <ApplicantsEmptyState
        title={emptyState.title}
        description={emptyState.description}
      />
    );
  }

  return (
    <>
      <UITable
        rows={rows}
        columns={columns}
        columnBuffer={columns.length}
        checkboxSelection
        onCellClick={onCellClick}
        getRowClassName={(params) => {
          if (!params.row.isBlocked) {
            return "row-hover";
          }
        }}
        selectionModel={filters.selectedApplicantIds.filter((id) =>
          rows.some((row) => row.id === id),
        )}
        onSelectionModelChange={onSelectionChange}
        keepNonExistentRowsSelected
        pageSize={filters.rowsCount || 10}
        contentSized
        hideFooter
        disableSelectionOnClick
      />
      {paginationTotal > 0 && (
        <UIPaginationBar
          currentPage={paginationCurrentPage}
          pages={paginationPages}
          pageSize={paginationPageSize}
          rangeTemplate={applicants.listApplicants.showingRange}
          rangeFrom={paginationFrom}
          rangeTo={paginationTo}
          rangeTotal={paginationTotal}
          rowsPerPageLabel={shared.numberOfRows}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          className="applicants-page-container__pagination"
        />
      )}
    </>
  );
};

ApplicantsListPanel.propTypes = {
  applicants: PropTypes.object.isRequired,
  shared: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  list: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  filters: PropTypes.object.isRequired,
  meta: PropTypes.object,
  emptyState: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
  onCellClick: PropTypes.func.isRequired,
  onSelectionChange: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,
};

ApplicantsListPanel.defaultProps = {
  meta: null,
};

export default ApplicantsListPanel;
